import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const googleRedirectUri = () => `${window.location.origin}/auth/google`;

export const GoogleAuthButton = ({ label = "Continue with Google" }) => {
  const [clientId, setClientId] = useState(null);

  useEffect(() => {
    api
      .get("/api/auth/google/config")
      .then((r) => setClientId(r.data.enabled ? r.data.client_id : null))
      .catch(() => setClientId(null));
  }, []);

  const start = () => {
    if (!clientId) {
      toast.error(apiError({ response: { data: { detail: "Google sign-in is not configured yet" } } }));
      return;
    }
    const state = Math.random().toString(36).slice(2);
    sessionStorage.setItem("cn_google_state", state);
    const params = new URLSearchParams({
      client_id: clientId,
      redirect_uri: googleRedirectUri(),
      response_type: "code",
      scope: "openid email profile",
      access_type: "online",
      include_granted_scopes: "true",
      prompt: "select_account",
      state,
    });
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
  };

  if (!clientId) return null;

  return (
    <div className="space-y-4">
      <Button
        type="button"
        variant="outline"
        onClick={start}
        className="w-full rounded-full border-slate-300 py-6 font-semibold hover:bg-slate-50"
        data-testid="google-auth-btn"
      >
        <svg className="mr-2 h-4 w-4" viewBox="0 0 48 48" aria-hidden="true">
          <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.6l6.7-6.7C35.6 2.4 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.8 6.1C12.3 13.2 17.7 9.5 24 9.5z" />
          <path fill="#4285F4" d="M46.1 24.6c0-1.6-.1-2.8-.4-4.1H24v8.2h12.5c-.3 2.1-1.6 5.2-4.6 7.3l7.6 5.9c4.5-4.2 6.6-10.3 6.6-17.3z" />
          <path fill="#FBBC05" d="M10.4 28.7A14.4 14.4 0 0 1 9.6 24c0-1.6.3-3.2.8-4.7l-7.8-6.1A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.8l7.8-6.1z" />
          <path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.8-5.8l-7.6-5.9c-2 1.4-4.8 2.4-8.2 2.4-6.3 0-11.7-3.7-13.6-9.1l-7.8 6.1C6.5 42.6 14.6 48 24 48z" />
        </svg>
        {label}
      </Button>
      <div className="flex items-center gap-3">
        <span className="h-px flex-1 bg-slate-200" />
        <span className="text-xs uppercase tracking-wider text-slate-400">or</span>
        <span className="h-px flex-1 bg-slate-200" />
      </div>
    </div>
  );
};
